<mat-dialog-content>Are you sure you want to remove this {{documentType}}?</mat-dialog-content>
<mat-dialog-actions>
  <button  mat-flat-button color="accent" mat-dialog-close>Cancel</button>

  <button  mat-flat-button color="primary"  (click)="confirm()">Confirm</button>
</mat-dialog-actions>